<template>
  <div>
    <b-modal
        v-model="showModalInternal"
        id="drugstore-or-groups-select-modal-form"
        scrollable
        :title="title || 'Wybierz apteki lub grupy'"
        title-class="font-18"
        size="xl"
        style="z-index:100010!important;"
        hide-footer
    >
      <div v-if="showModalInternal">
        <ul class="nav nav-tabs">
          <li class="nav-item common-tab">
            <a :class="drugstoresTabClass" aria-current="page" @click="openTab('DRUGSTORES')">Apteki</a>
          </li>
          <li class="nav-item common-tab">
            <a :class="groupsTabClass" @click="openTab('GROUPS')">Grupy aptek</a>
          </li>
        </ul>
        <div class="row top-space">
          <!-- Tab 1: Drugstores -->
          <div v-if="currentTab === 'DRUGSTORES'">
            <DrugstoresList
                ref="drugstoresList"
                :multiselect="multiselectDrugstores"
                @onSelect="selectDrugstores"
                :showRowActions="false"
                :showMassActions="false"
                :selectedDrugstoresData="selectedDrugstoresData"
                :showAddButton="false"
                :disableInitiallyCheckedItems="disableInitiallyCheckedItems"
                :ignoreInitiallyCheckedItems="ignoreInitiallyCheckedItems"
                :visibleColumnsFilter="visibleColumnsFilter"
                :enableRowSelection="enableRowSelection"
                :showCheckboxColumn="showCheckboxColumn"
                :displayInBootstrapRow="true"
            >
              <template #bottom>
                <div class="modal-footer-container">
                  <div class="modal-footer-bottom">
                    <button class="btn btn-primary" @click="applySelectDrugstores" :disabled="!selectedDrugstores || selectedDrugstores.length === 0">
                      {{ okTitle }}
                    </button>
                  </div>
                </div>
              </template>
            </DrugstoresList>
          </div>

          <!-- Tab 2: Groups -->
          <div v-else-if="currentTab === 'GROUPS'">
            <div class="windows-like-breadcrumb-card shadow-sm p-3">
              <CommonTable2
                  :table="groupsTableData"
                  :key="groupsTableData.data"
                  rowIdentifier="id"
                  @onCheckItem="selectGroups($event)"
                  :showPaginationTop="false"
                  :showPaginationBottom="false"
                  :showMassActions="false"
                  :showRowActions="false"
                  :multiselect="multiselectGroups"
                  :enableRowSelection="true"
                  :showCheckboxColumn="true"
                  :initiallyCheckedItemsData="selectedGroupsData"
              />
              <div class="modal-footer-container mt-3">
                <div class="modal-footer-bottom">
                  <button class="btn btn-primary" @click="applySelectGroups" :disabled="!selectedGroups || selectedGroups.length === 0">
                    {{ okTitle }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { BModal } from 'bootstrap-vue-next'
import DrugstoresList from './DrugstoresList.vue'
import CommonTable2 from "@/components/widgets/CommonTable2.vue"
import { useCommonAppModule } from "@/state/pinia/commonAppModule"

export default defineComponent({
  name: 'DrugstoreOrGroupsTabsModal',
  components: { BModal, DrugstoresList, CommonTable2 },
  props: {
    showModal: { type: Boolean, required: true },
    title: { type: String, default: 'Wybierz apteki lub grupy' },
    multiselectDrugstores: { type: Boolean, default: true },
    multiselectGroups: { type: Boolean, default: true },
    selectedDrugstoresData: { type: Array, default: () => [] },
    selectedGroupsData: { type: Array, default: () => [] },
    okTitle: { type: String, default: 'Wybierz' },
    disableInitiallyCheckedItems: { type: Boolean, default: () => false },
    ignoreInitiallyCheckedItems: { type: Boolean, default: () => false },
    visibleColumnsFilter: { type: Array, default: () => [] },
    enableRowSelection: { type: Boolean, default: () => true },
    showCheckboxColumn: { type: Boolean, default: () => true },
  },
  emits: ['update:showModal', 'onApply', 'onApplyDrugstores', 'onApplyGroups', 'onClose'],
  data() {
    return {
      showModalInternal: this.showModal,
      currentTab: 'DRUGSTORES',
      drugstoresTabClass: 'nav-link active',
      groupsTabClass: 'nav-link',
      selectedDrugstores: null,
      selectedGroups: null,
      groupsTableData: {
        headers: [
          { key: "name", text: "Nazwa", type: "text", sortable: true },
          { key: "description", text: "Opis", type: "text", sortable: false },
          { key: "priority", text: "Priorytet", type: "text", sortable: true }
        ],
        data: []
      }
    }
  },
  computed: {
    commonModule() {
      return useCommonAppModule()
    }
  },
  methods: {
    openTab(tab) {
      this.currentTab = tab
      if (tab === 'DRUGSTORES') {
        this.drugstoresTabClass = 'nav-link active'
        this.groupsTabClass = 'nav-link'
      } else {
        this.drugstoresTabClass = 'nav-link'
        this.groupsTabClass = 'nav-link active'
        if (this.groupsTableData.data.length === 0) {
          this.fetchGroups()
        }
      }
    },
    fetchGroups() {
      this.commonModule.httpGetDrugstoreGroupsAll().then(() => {
        this.groupsTableData.data = this.commonModule.getDrugstoreGroups
      })
    },
    selectDrugstores(itemsData) {
      this.selectedDrugstores = itemsData
    },
    selectGroups(event) {
      console.log("Selected groups:", event.itemsData)
      this.selectedGroups = event.itemsData
    },
    applySelectDrugstores() {
      this.$emit('onApplyDrugstores', this.selectedDrugstores)
      this.$emit('onApply', { type: 'DRUGSTORES', items: this.selectedDrugstores })
      this.closeModal()
    },
    applySelectGroups() {
      this.$emit('onApplyGroups', this.selectedGroups)
      this.$emit('onApply', { type: 'GROUPS', items: this.selectedGroups })
      this.closeModal()
    },
    closeModal() {
      this.showModalInternal = false
      this.$emit('onClose')
    }
  },
  watch: {
    showModal(newValue) {
      this.showModalInternal = newValue
      if (newValue && this.currentTab === 'GROUPS') {
        this.fetchGroups()
      }
    },
    showModalInternal(newValue) {
      this.$emit('update:showModal', newValue)
    }
  }
})
</script>

<style scoped>
.top-space { margin-top: 20px; }
.common-tab { cursor: pointer; }
.modal-footer-container { position: sticky; bottom: -19px; left: 0; width: 100%; background: #fff; z-index: 60; padding: 0; }
.modal-footer-bottom { display: flex; justify-content: flex-end; gap: 12px; padding: 18px 24px; }
</style>
